export default __webpack_public_path__ + "static/media/Gerenciar Empresa (Real Size).a3de9e80.svg";